import { Union } from "./fable_modules/fable-library-js.4.29.0/Types.js";
import { list_type, tuple_type, string_type, class_type, option_type, enum_type, int32_type, float64_type, bool_type, union_type, uint32_type } from "./fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Profession, Skills as Skills_1, Skill, Profession_$reflection } from "./Model/Skills.js";
import { CropAmountSettings, Date$_$reflection } from "./Model/Crops.js";
import { GameDataModule_product, GameVariables, Location_$reflection } from "./Model/Game.js";
import { UIState, PresetModule_hasId, Preset, Ranker as Ranker_1, CropTabState, CropFiltersModule_empty, CropFilters, Settings, ProfitSettings, Selections, Selection$2, Settings_$reflection, Preset_$reflection, OpenDetails_$reflection, SettingsTab_$reflection, OptimizationObjective_$reflection, AppMode_$reflection, TimeNormalization_$reflection, RankMetric_$reflection, RankItem_$reflection, SeedStrategy_$reflection } from "./Types.js";
import { FSharpSet__Contains, FSharpSet_op_Subtraction, FSharpSet_op_Addition, remove, add } from "./fable_modules/fable-library-js.4.29.0/Set.js";
import { Multipliers as Multipliers_1 } from "./Model/Items.js";
import { add as add_1, remove as remove_1, change, map as map_3 } from "./fable_modules/fable-library-js.4.29.0/Map.js";
import { bind, map as map_4 } from "./fable_modules/fable-library-js.4.29.0/Option.js";
import { getItemFromDict } from "./fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { tryFindIndex, removeAt, item as item_1, updateAt, cons } from "./fable_modules/fable-library-js.4.29.0/List.js";
import { Option_defaultOrMap } from "./Model/Prelude.js";

export class SkillMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetLevel", "SetBuff"];
    }
}

export function SkillMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.SkillMessage", [], SkillMessage, () => [[["Item", uint32_type]], [["Item", uint32_type]]]);
}

export class SkillsMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetFarming", "SetForaging", "SetProfession", "SetIgnoreSkillLevelRequirements", "SetIgnoreProfessionConflicts"];
    }
}

export function SkillsMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.SkillsMessage", [], SkillsMessage, () => [[["Item", SkillMessage_$reflection()]], [["Item", SkillMessage_$reflection()]], [["Item1", Profession_$reflection()], ["Item2", bool_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

export class CropAmountMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSpecialCharm", "SetLuckBuff", "SetGiantCropOrientationsPerTile", "SetShavingToolLevel"];
    }
}

export function CropAmountMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.CropAmountMessage", [], CropAmountMessage, () => [[["Item", bool_type]], [["Item", uint32_type]], [["Item", float64_type]], [["Item", option_type(enum_type("StardewValleyStonks.ToolLevel", int32_type, [["Normal", 0], ["Copper", 1], ["Steel", 2], ["Gold", 3], ["Iridium", 4]]))]]]);
}

export class MultipliersMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetProfitMargin", "SetBearsKnowledge", "SetTillerForForagedFruit"];
    }
}

export function MultipliersMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.MultipliersMessage", [], MultipliersMessage, () => [[["Item", float64_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

export class GameVariablesMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetStartDate", "SetEndDate", "SetLocation", "SetSkills", "SetMultipliers", "SetCropAmount", "SetJojaMembership", "SetIrrigated", "SetQualityArtisanProducts"];
    }
}

export function GameVariablesMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.GameVariablesMessage", [], GameVariablesMessage, () => [[["Item", Date$_$reflection()]], [["Item", Date$_$reflection()]], [["Item", Location_$reflection()]], [["Item", SkillsMessage_$reflection()]], [["Item", MultipliersMessage_$reflection()]], [["Item", CropAmountMessage_$reflection()]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

export class SelectionMessage$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSelected", "SetManySelected"];
    }
}

export function SelectionMessage$1_$reflection(gen0) {
    return union_type("StardewValleyStonks.WebApp.Update.SelectionMessage`1", [gen0], SelectionMessage$1, () => [[["Item1", gen0], ["Item2", bool_type]], [["Item1", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [gen0])], ["Item2", bool_type]]]);
}

export class CustomMessage$2 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddCustom", "EditCustom", "RemoveCustom", "SelectCustom"];
    }
}

export function CustomMessage$2_$reflection(gen0, gen1) {
    return union_type("StardewValleyStonks.WebApp.Update.CustomMessage`2", [gen0, gen1], CustomMessage$2, () => [[["Item1", gen0], ["Item2", gen1]], [["Item1", gen0], ["Item2", gen1]], [["Item", gen0]], [["Item", SelectionMessage$1_$reflection(gen0)]]]);
}

export class SelectionsMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SelectCrops", "SelectSeedPrices", "SelectNoFertilizer", "SelectFertilizers", "SelectFertilizerPrices", "SelectSellRaw", "SelectProducts", "SelectUseHarvestedSeeds", "SelectUseSeedMaker", "SelectUseForageSeeds", "SetCustomFertilizerPrice", "SetCustomSeedPrice", "SetCustomSellPrice"];
    }
}

export function SelectionsMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.SelectionsMessage", [], SelectionsMessage, () => [[["Item", SelectionMessage$1_$reflection(uint32_type)]], [["Item1", string_type], ["Item2", SelectionMessage$1_$reflection(uint32_type)]], [["Item", bool_type]], [["Item", SelectionMessage$1_$reflection(string_type)]], [["Item1", string_type], ["Item2", SelectionMessage$1_$reflection(string_type)]], [["Item", SelectionMessage$1_$reflection(uint32_type)]], [["Item1", string_type], ["Item2", SelectionMessage$1_$reflection(uint32_type)]], [["Item", SelectionMessage$1_$reflection(uint32_type)]], [["Item", SelectionMessage$1_$reflection(uint32_type)]], [["Item", SelectionMessage$1_$reflection(uint32_type)]], [["Item", CustomMessage$2_$reflection(string_type, uint32_type)]], [["Item", CustomMessage$2_$reflection(uint32_type, uint32_type)]], [["Item", CustomMessage$2_$reflection(uint32_type, tuple_type(uint32_type, bool_type))]]]);
}

export class ProfitMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSeedStrategy", "SetPayForFertilizer", "SetPayForDestroyedFertilizer"];
    }
}

export function ProfitMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.ProfitMessage", [], ProfitMessage, () => [[["Item", SeedStrategy_$reflection()]], [["Item", bool_type]], [["Item", bool_type]]]);
}

export class SettingsMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetGameVariables", "SetProfit", "SetSelections"];
    }
}

export function SettingsMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.SettingsMessage", [], SettingsMessage, () => [[["Item", GameVariablesMessage_$reflection()]], [["Item", ProfitMessage_$reflection()]], [["Item", SelectionsMessage_$reflection()]]]);
}

export class CropFiltersMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetItemNameSearch", "SetInSeason", "SetSeasons", "SetRegrows", "SetGiant", "SetForage", "ClearFilters"];
    }
}

export function CropFiltersMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.CropFiltersMessage", [], CropFiltersMessage, () => [[["Item", string_type]], [["Item", bool_type]], [["Item", enum_type("StardewValleyStonks.Seasons", int32_type, [["None", 0], ["Spring", 1], ["Summer", 2], ["Fall", 4], ["Winter", 8], ["All", 15]])]], [["Item", option_type(bool_type)]], [["Item", option_type(bool_type)]], [["Item", option_type(bool_type)]], []]);
}

export class CropTabMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetCropFilters", "SetCropSort", "SetProductSort", "SetSeedSort", "SetProductQuality", "SetNormalizeProductPrices"];
    }
}

export function CropTabMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.CropTabMessage", [], CropTabMessage, () => [[["Item", CropFiltersMessage_$reflection()]], [["Item", tuple_type(uint32_type, bool_type)]], [["Item", tuple_type(uint32_type, bool_type)]], [["Item", tuple_type(uint32_type, bool_type)]], [["Item", enum_type("StardewValleyStonks.Quality", int32_type, [["Normal", 0], ["Silver", 1], ["Gold", 2], ["Iridium", 3]])]], [["Item", bool_type]]]);
}

export class RankerMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetRankItem", "SetRankMetric", "SetTimeNormalization", "SetShowInvalid", "SetBrushSpan", "SetSelectedCropAndFertilizer"];
    }
}

export function RankerMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.RankerMessage", [], RankerMessage, () => [[["Item", RankItem_$reflection()]], [["Item", RankMetric_$reflection()]], [["Item", TimeNormalization_$reflection()]], [["Item", bool_type]], [["Item1", uint32_type], ["Item2", uint32_type]], [["Item", option_type(tuple_type(option_type(uint32_type), option_type(option_type(string_type))))]]]);
}

export class UIMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetAppMode", "SetRanker", "SetOptimizationObjective", "SetSettingsTab", "SetDetailsOpen", "SetCropTabState", "SetFertilizerSort", "SetFertilizerPriceSort"];
    }
}

export function UIMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.UIMessage", [], UIMessage, () => [[["Item", AppMode_$reflection()]], [["Item", RankerMessage_$reflection()]], [["Item", OptimizationObjective_$reflection()]], [["Item", SettingsTab_$reflection()]], [["Item1", OpenDetails_$reflection()], ["Item2", bool_type]], [["Item", CropTabMessage_$reflection()]], [["Item", tuple_type(uint32_type, bool_type)]], [["Item", tuple_type(uint32_type, bool_type)]]]);
}

export class PresetsMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadSaveGame", "SavePreset", "RenamePreset", "DeletePreset"];
    }
}

export function PresetsMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.PresetsMessage", [], PresetsMessage, () => [[["Item", Preset_$reflection()]], [["Item1", string_type], ["Item2", Settings_$reflection()]], [["Item1", int32_type], ["Item2", string_type]], [["Item", int32_type]]]);
}

export class StateMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetSettings", "SetUI", "LoadSettings"];
    }
}

export function StateMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.StateMessage", [], StateMessage, () => [[["Item", SettingsMessage_$reflection()]], [["Item", UIMessage_$reflection()]], [["Item", Settings_$reflection()]]]);
}

export class AppMessage extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetState", "SetPresets", "SyncPresets", "NuclearReset"];
    }
}

export function AppMessage_$reflection() {
    return union_type("StardewValleyStonks.WebApp.Update.AppMessage", [], AppMessage, () => [[["Item", StateMessage_$reflection()]], [["Item", PresetsMessage_$reflection()]], [["Item", list_type(Preset_$reflection())]], []]);
}

function setSelected(makeSelected, value, set$) {
    if (makeSelected) {
        return add(value, set$);
    }
    else {
        return remove(value, set$);
    }
}

export function skill(msg, skill_1) {
    if (msg.tag === 1) {
        return new Skill(skill_1.Level, msg.fields[0]);
    }
    else {
        return new Skill(msg.fields[0], skill_1.Buff);
    }
}

export function skills(msg, skills_1) {
    switch (msg.tag) {
        case 1:
            return new Skills_1(skills_1.Farming, skill(msg.fields[0], skills_1.Foraging), skills_1.Professions, skills_1.IgnoreSkillLevelRequirements, skills_1.IgnoreProfessionConflicts);
        case 2: {
            const selected = msg.fields[1];
            const profession = msg.fields[0];
            return new Skills_1(skills_1.Farming, skills_1.Foraging, setSelected(selected, profession, skills_1.IgnoreProfessionConflicts ? skills_1.Professions : ((profession.tag === 1) ? (selected ? remove(new Profession(2, []), add(new Profession(0, []), skills_1.Professions)) : skills_1.Professions) : ((profession.tag === 2) ? (selected ? remove(new Profession(1, []), add(new Profession(0, []), skills_1.Professions)) : skills_1.Professions) : ((profession.tag === 3) ? (selected ? skills_1.Professions : remove(new Profession(4, []), skills_1.Professions)) : ((profession.tag === 4) ? (selected ? add(new Profession(3, []), skills_1.Professions) : skills_1.Professions) : (selected ? skills_1.Professions : remove(new Profession(2, []), remove(new Profession(1, []), skills_1.Professions)))))))), skills_1.IgnoreSkillLevelRequirements, skills_1.IgnoreProfessionConflicts);
        }
        case 3:
            return new Skills_1(skills_1.Farming, skills_1.Foraging, skills_1.Professions, msg.fields[0], skills_1.IgnoreProfessionConflicts);
        case 4:
            return new Skills_1(skills_1.Farming, skills_1.Foraging, skills_1.Professions, skills_1.IgnoreSkillLevelRequirements, msg.fields[0]);
        default:
            return new Skills_1(skill(msg.fields[0], skills_1.Farming), skills_1.Foraging, skills_1.Professions, skills_1.IgnoreSkillLevelRequirements, skills_1.IgnoreProfessionConflicts);
    }
}

export function cropAmount(msg, amount) {
    switch (msg.tag) {
        case 1:
            return new CropAmountSettings(amount.SpecialCharm, msg.fields[0], amount.GiantCropOrientationsPerTile, amount.ShavingToolLevel);
        case 2:
            return new CropAmountSettings(amount.SpecialCharm, amount.LuckBuff, msg.fields[0], amount.ShavingToolLevel);
        case 3:
            return new CropAmountSettings(amount.SpecialCharm, amount.LuckBuff, amount.GiantCropOrientationsPerTile, msg.fields[0]);
        default:
            return new CropAmountSettings(msg.fields[0], amount.LuckBuff, amount.GiantCropOrientationsPerTile, amount.ShavingToolLevel);
    }
}

export function multipliers(msg, multipliers_1) {
    switch (msg.tag) {
        case 1:
            return new Multipliers_1(multipliers_1.ProfitMargin, msg.fields[0], multipliers_1.TillerForForagedFruit);
        case 2:
            return new Multipliers_1(multipliers_1.ProfitMargin, multipliers_1.BearsKnowledge, msg.fields[0]);
        default:
            return new Multipliers_1(msg.fields[0], multipliers_1.BearsKnowledge, multipliers_1.TillerForForagedFruit);
    }
}

export function gameVariables(msg, vars) {
    switch (msg.tag) {
        case 1:
            return new GameVariables(vars.StartDate, msg.fields[0], vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 2:
            return new GameVariables(vars.StartDate, vars.EndDate, msg.fields[0], vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 3:
            return new GameVariables(vars.StartDate, vars.EndDate, vars.Location, skills(msg.fields[0], vars.Skills), vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 4:
            return new GameVariables(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, multipliers(msg.fields[0], vars.Multipliers), vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 5:
            return new GameVariables(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, cropAmount(msg.fields[0], vars.CropAmount), vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
        case 6:
            return new GameVariables(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, msg.fields[0], vars.Irrigated, vars.QualityArtisanProducts);
        case 7:
            return new GameVariables(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, msg.fields[0], vars.QualityArtisanProducts);
        case 8:
            return new GameVariables(vars.StartDate, vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, msg.fields[0]);
        default:
            return new GameVariables(msg.fields[0], vars.EndDate, vars.Location, vars.Skills, vars.Multipliers, vars.CropAmount, vars.JojaMembership, vars.Irrigated, vars.QualityArtisanProducts);
    }
}

function select(msg, set$) {
    if (msg.tag === 1) {
        const keys = msg.fields[0];
        if (msg.fields[1]) {
            return FSharpSet_op_Addition(set$, keys);
        }
        else {
            return FSharpSet_op_Subtraction(set$, keys);
        }
    }
    else {
        return setSelected(msg.fields[1], msg.fields[0], set$);
    }
}

function mapSelectWith(containsKey, key, msg, map) {
    if (msg.tag === 1) {
        return map_3((id$0027_1, selection) => {
            if (containsKey(id$0027_1, key) && FSharpSet__Contains(msg.fields[0], id$0027_1)) {
                return setSelected(msg.fields[1], key, selection);
            }
            else {
                return selection;
            }
        }, map);
    }
    else {
        return change(msg.fields[0], (option) => map_4((set$) => setSelected(msg.fields[1], key, set$), option), map);
    }
}

function mapSelect(data, key, msg, map) {
    return mapSelectWith((id$0027, key_1) => {
        const arg10$0040_1 = getItemFromDict(data.fields[0], id$0027);
        return arg10$0040_1.fields[0].has(key_1);
    }, key, msg, map);
}

export function custom(msg, selection) {
    switch (msg.tag) {
        case 2: {
            const key_1 = msg.fields[0];
            const Selected = remove(key_1, selection.Selected);
            return new Selection$2(remove_1(key_1, selection.Values), Selected);
        }
        case 1:
            return new Selection$2(add_1(msg.fields[0], msg.fields[1], selection.Values), selection.Selected);
        case 3:
            return new Selection$2(selection.Values, select(msg.fields[0], selection.Selected));
        default: {
            const key = msg.fields[0];
            return new Selection$2(add_1(key, msg.fields[1], selection.Values), add(key, selection.Selected));
        }
    }
}

export function selections(data, msg, selection) {
    switch (msg.tag) {
        case 1:
            return new Selections(selection.Crops, mapSelect(data.SeedPrices, msg.fields[0], msg.fields[1], selection.SeedPrices), selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 2:
            return new Selections(selection.Crops, selection.SeedPrices, msg.fields[0], selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 3:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, select(msg.fields[0], selection.Fertilizers), selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 4:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, mapSelect(data.FertilizerPrices, msg.fields[0], msg.fields[1], selection.FertilizerPrices), selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 5:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, select(msg.fields[0], selection.SellRaw), selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 6:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, mapSelectWith((item, processor_1) => (GameDataModule_product(data, processor_1, item) != null), msg.fields[0], msg.fields[1], selection.Products), selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 7:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, select(msg.fields[0], selection.UseHarvestedSeeds), selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 8:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, select(msg.fields[0], selection.UseSeedMaker), selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 9:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, select(msg.fields[0], selection.UseForageSeeds), selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 10:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, custom(msg.fields[0], selection.CustomFertilizerPrices), selection.CustomSellPrices);
        case 11:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, custom(msg.fields[0], selection.CustomSeedPrices), selection.CustomFertilizerPrices, selection.CustomSellPrices);
        case 12:
            return new Selections(selection.Crops, selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, custom(msg.fields[0], selection.CustomSellPrices));
        default:
            return new Selections(select(msg.fields[0], selection.Crops), selection.SeedPrices, selection.NoFertilizer, selection.Fertilizers, selection.FertilizerPrices, selection.SellRaw, selection.Products, selection.UseHarvestedSeeds, selection.UseSeedMaker, selection.UseForageSeeds, selection.CustomSeedPrices, selection.CustomFertilizerPrices, selection.CustomSellPrices);
    }
}

export function profit(msg, profit_1) {
    switch (msg.tag) {
        case 1:
            return new ProfitSettings(profit_1.SeedStrategy, msg.fields[0], profit_1.PayForDestroyedFertilizer);
        case 2:
            return new ProfitSettings(profit_1.SeedStrategy, profit_1.PayForFertilizer, msg.fields[0]);
        default:
            return new ProfitSettings(msg.fields[0], profit_1.PayForFertilizer, profit_1.PayForDestroyedFertilizer);
    }
}

export function settings(data, msg, settings_1) {
    switch (msg.tag) {
        case 1:
            return new Settings(settings_1.Game, profit(msg.fields[0], settings_1.Profit), settings_1.Selected);
        case 2:
            return new Settings(settings_1.Game, settings_1.Profit, selections(data, msg.fields[0], settings_1.Selected));
        default:
            return new Settings(gameVariables(msg.fields[0], settings_1.Game), settings_1.Profit, settings_1.Selected);
    }
}

export function cropFilters(msg, filters) {
    switch (msg.tag) {
        case 1:
            return new CropFilters(filters.ItemNameSearch, msg.fields[0], filters.Seasons, filters.Regrows, filters.Giant, filters.Forage);
        case 2:
            return new CropFilters(filters.ItemNameSearch, filters.InSeason, msg.fields[0], filters.Regrows, filters.Giant, filters.Forage);
        case 3:
            return new CropFilters(filters.ItemNameSearch, filters.InSeason, filters.Seasons, msg.fields[0], filters.Giant, filters.Forage);
        case 4:
            return new CropFilters(filters.ItemNameSearch, filters.InSeason, filters.Seasons, filters.Regrows, msg.fields[0], filters.Forage);
        case 5:
            return new CropFilters(filters.ItemNameSearch, filters.InSeason, filters.Seasons, filters.Regrows, filters.Giant, msg.fields[0]);
        case 6:
            return CropFiltersModule_empty;
        default:
            return new CropFilters(msg.fields[0], filters.InSeason, filters.Seasons, filters.Regrows, filters.Giant, filters.Forage);
    }
}

export function cropTab(msg, state_1) {
    switch (msg.tag) {
        case 1:
            return new CropTabState(state_1.Filters, [msg.fields[0][0], msg.fields[0][1]], state_1.ProductSort, state_1.SeedSort, state_1.ProductQuality, state_1.NormalizeProductPrices);
        case 2:
            return new CropTabState(state_1.Filters, state_1.CropSort, [msg.fields[0][0], msg.fields[0][1]], state_1.SeedSort, state_1.ProductQuality, state_1.NormalizeProductPrices);
        case 3:
            return new CropTabState(state_1.Filters, state_1.CropSort, state_1.ProductSort, [msg.fields[0][0], msg.fields[0][1]], state_1.ProductQuality, state_1.NormalizeProductPrices);
        case 4:
            return new CropTabState(state_1.Filters, state_1.CropSort, state_1.ProductSort, state_1.SeedSort, msg.fields[0], state_1.NormalizeProductPrices);
        case 5:
            return new CropTabState(state_1.Filters, state_1.CropSort, state_1.ProductSort, state_1.SeedSort, state_1.ProductQuality, msg.fields[0]);
        default:
            return new CropTabState(cropFilters(msg.fields[0], state_1.Filters), state_1.CropSort, state_1.ProductSort, state_1.SeedSort, state_1.ProductQuality, state_1.NormalizeProductPrices);
    }
}

export function ranker(msg, ranker_1) {
    switch (msg.tag) {
        case 1:
            return new Ranker_1(ranker_1.RankItem, msg.fields[0], ranker_1.TimeNormalization, ranker_1.ShowInvalid, ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
        case 2:
            return new Ranker_1(ranker_1.RankItem, ranker_1.RankMetric, msg.fields[0], ranker_1.ShowInvalid, ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
        case 3:
            return new Ranker_1(ranker_1.RankItem, ranker_1.RankMetric, ranker_1.TimeNormalization, msg.fields[0], ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
        case 4:
            return new Ranker_1(ranker_1.RankItem, ranker_1.RankMetric, ranker_1.TimeNormalization, ranker_1.ShowInvalid, [msg.fields[0], msg.fields[1]], ranker_1.SelectedCropAndFertilizer);
        case 5:
            return new Ranker_1(ranker_1.RankItem, ranker_1.RankMetric, ranker_1.TimeNormalization, ranker_1.ShowInvalid, ranker_1.BrushSpan, msg.fields[0]);
        default:
            return new Ranker_1(msg.fields[0], ranker_1.RankMetric, ranker_1.TimeNormalization, ranker_1.ShowInvalid, ranker_1.BrushSpan, ranker_1.SelectedCropAndFertilizer);
    }
}

export function presets(msg, presets_1) {
    let bind$0040;
    switch (msg.tag) {
        case 1:
            return cons(new Preset(msg.fields[0], undefined, msg.fields[1]), presets_1);
        case 2: {
            const i_1 = msg.fields[0] | 0;
            return updateAt(i_1, (bind$0040 = item_1(i_1, presets_1), new Preset(msg.fields[1], bind$0040.UniqueId, bind$0040.Settings)), presets_1);
        }
        case 3:
            return removeAt(msg.fields[0], presets_1);
        default: {
            const preset = msg.fields[0];
            return Option_defaultOrMap(cons(preset, presets_1), (i) => updateAt(i, preset, presets_1), bind((uniqueId) => tryFindIndex((preset_1) => PresetModule_hasId(uniqueId, preset_1), presets_1), preset.UniqueId));
        }
    }
}

export function ui(msg, ui_1) {
    switch (msg.tag) {
        case 1:
            return new UIState(ui_1.Mode, ranker(msg.fields[0], ui_1.Ranker), ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 2:
            return new UIState(ui_1.Mode, ui_1.Ranker, msg.fields[0], ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 3:
            return new UIState(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, msg.fields[0], ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 4:
            return new UIState(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, setSelected(msg.fields[1], msg.fields[0], ui_1.OpenDetails), ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 5:
            return new UIState(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, cropTab(msg.fields[0], ui_1.CropTab), ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
        case 6:
            return new UIState(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, [msg.fields[0][0], msg.fields[0][1]], ui_1.FertilizerPriceSort);
        case 7:
            return new UIState(ui_1.Mode, ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, [msg.fields[0][0], msg.fields[0][1]]);
        default:
            return new UIState(msg.fields[0], ui_1.Ranker, ui_1.OptimizationObjective, ui_1.SettingsTab, ui_1.OpenDetails, ui_1.CropTab, ui_1.FertilizerSort, ui_1.FertilizerPriceSort);
    }
}

export function state(msg, data, oldSettings, oldUI) {
    switch (msg.tag) {
        case 1:
            return [oldSettings, ui(msg.fields[0], oldUI)];
        case 2:
            return [msg.fields[0], oldUI];
        default:
            return [settings(data, msg.fields[0], oldSettings), oldUI];
    }
}

//# sourceMappingURL=Update.js.map
